import { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

import { Range, WeeksGroup, WeeksInput, WeeksLabel, WeeksError } from './styles'
import TitleGroup from './components/TitleGroup'

const showErrors = (errors, name) => {
  const errorMessage = {
    min: 'Limite minimo de 1 semana.',
    max: 'Limite máximo de 12 semanas.'
  }

  if (errors[name]) {
    return (
      <WeeksError>
        {errorMessage[errors[name].type]}
      </WeeksError>
    )
  }
}

const RangeSlider = ({
  min,
  max,
  step,
  name,
  errors,
  reference,
  defaultValue
}) => {
  const [range, setRange] = useState(defaultValue)
  const titleItems = Array.from(Array(max + 1).keys())

  const onRangeChange = ({ target: { value } }) => {
    if (value <= 0 || value === '') {
      return setRange(0)
    }

    return setRange(Math.round(parseFloat(value)))
  }

  return (
    <Fragment>
      <TitleGroup items={titleItems} />
      <Range
        type="range"
        name={name}
        min={min}
        max={max}
        step={step}
        value={range}
        onChange={onRangeChange}
      />
      <WeeksGroup>
        <WeeksInput
          type="number"
          name={name}
          ref={reference}
          value={range}
          onChange={onRangeChange}
          hasError={!!errors[name]}
          readOnly
        />
        <WeeksLabel>Semanas</WeeksLabel>
        {showErrors(errors, name)}
      </WeeksGroup>
    </Fragment>
  )
}

RangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object,
  reference: PropTypes.func,
  defaultValue: PropTypes.string.isRequired
}

RangeSlider.defaultProps = {
  min: 0,
  max: 12,
  step: 2,
  name: 'range_slider',
  errors: {},
  defaultValue: ''
}

export default RangeSlider
